import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';

const purchaseStatuses = [
  {
    value: 'arranged',
    display_name: 'Arranged',
  },
  {
    value: 'preauth',
    display_name: 'Authorized',
  },
  {
    value: 'cancelled',
    display_name: 'Cancelled',
  },
  {
    value: 'chargeback',
    display_name: 'Charged Back',
  },
  {
    value: 'complete',
    display_name: 'Complete',
  },
  {
    value: 'credit',
    display_name: 'Credited',
  },
  {
    value: 'denied_arrangement',
    display_name: 'Denied Arrangement',
  },
  {
    value: 'echeck_failed',
    display_name: 'Echeck Failed',
  },
  {
    value: 'echeck_in_review',
    display_name: 'Echeck in review',
  },
  {
    value: 'overdue',
    display_name: 'Past Due',
  },
  {
    value: 'pending',
    display_name: 'Pending',
  },
  {
    value: 'pending_arrangement',
    display_name: 'Pending Arrangement',
  },
  {
    value: 'offload',
    display_name: 'Pending Authorization',
  },
];
const purchaseStatusesOptions = purchaseStatuses.map((status) => [
  status.value,
  status.display_name,
]);

let OrdersFilters = ({ handleSubmit, onResetFilters }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div style={{ maxWidth: '330px' }}>
        <Field
          component={InputField}
          name="user_profile"
          label="User Profile ID"
        />
        <Field component={InputField} name="purchase" label="Purchase" />
        <Field
          component={SelectField}
          name="purchase_status"
          empty="All statuses"
          options={purchaseStatusesOptions}
          label="Purchase Status"
        />
      </div>
      <div>
        <button className="btn btn-primary mar-r" type="submit">
          Filter
        </button>
        <button
          className="btn btn-default"
          type="button"
          onClick={onResetFilters}
        >
          Reset
        </button>
      </div>
    </form>
  );
};

OrdersFilters = reduxForm({
  form: 'ordersFilters',
  enableReinitialize: true,
})(OrdersFilters);

export default OrdersFilters;
